'use client'

import { motion, type Variants } from 'framer-motion'
import type { CSSProperties, ReactNode } from 'react'

const variants: Variants = {
  hidden: {
    y: 10,
    opacity: 0,
  },
  show: {
    y: 0,
    opacity: 1,
    transition: {
      ease: [0.4, 0, 0.2, 1],
      duration: 0.5,
    },
  },
}

export interface PageTransitionProps {
  children: ReactNode
  className?: string
  style?: CSSProperties
}

export default function PageTransition({
  children,
  className,
  style,
}: PageTransitionProps) {
  return (
    <motion.div
      variants={variants}
      initial='hidden'
      animate='show'
      className={className}
      style={style}
    >
      {children}
    </motion.div>
  )
}
